export default "__VITE_ASSET__14298313__"